import moment from 'moment'

function getDateNowDiffer (start, limitDays) {
  let diffTime = moment(start, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'))
  let duration = moment.duration(diffTime)
  let days = duration.asDays() * -1
  return days > limitDays
}

function getDateDiffer (start, end) {
  let diffTime = moment(end, 'YYYY-MM-DD').diff(moment(start, 'YYYY-MM-DD'))
  let duration = moment.duration(diffTime)
  let days = Math.floor(duration.asDays())
  return days >= 0
}

export {
  getDateNowDiffer,
  getDateDiffer
}



// WEBPACK FOOTER //
// ./src/components/menus/commerceCustom/util/baseUtil.js